export default __webpack_public_path__ + "static/media/grafema_nutrana_03.9f23ab89.gif";